import { Component, OnInit, Input } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  iconSize: number = 2.5;
  breadCrumbSize: number = 1.2;
  @Input() breadcrumbs: string = '';
  // breadcrumbs: string[] = ['Curso','Clase','Actividades'];

  constructor(
    private watcher: MediaObserver,
    private _location: Location,
  ) { }

  ngOnInit(): void {
    this.watcher.media$
      .subscribe((change: MediaChange) => {
        switch (change.mqAlias) {
          case 'xs':
            this.iconSize = 2.5;
            this.breadCrumbSize = 0.6;
            break;
          /* case 'sm':
            break;
          case 'md':
            break;
          case 'lg':
            break;
          case 'xl':
            break; */
          default:
            this.iconSize = 2.5;
            this.breadCrumbSize = 1.2;
            break;
        }
      });
  }

  goBack() {
      this._location.back();
  }
}
